export default __webpack_public_path__ + "static/media/Path 139.f0ff8f72.svg";